import { useEffect, useState } from 'react';
import {
  Box,
  TextField,
  MenuItem,
  Button,
  Typography,
  FormControl,
  InputLabel,
  Select,
  Paper,
  FormHelperText,
  CircularProgress,
} from '@mui/material';
import { ApiServices } from '../../utils/ApiService';
import { useSnackbar } from 'notistack';

const fieldStyle = { marginBottom: '20px' };

const AddEmployeePage = () => {
  const { enqueueSnackbar } = useSnackbar();

  const registerData = {
    name: '',
    gender: '',
    dob: '',
    phoneNo: '',
    email: '',
    address: '',
    branch: '',
    role: '',
  };

  const [data, setData] = useState({ ...registerData });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [roleTab, setRoleTab] = useState([])
  const [branchTab, setBranchTab] = useState([])

  const validate = () => {
    const newErrors = {};
    if (!data.name.trim()) newErrors.name = 'Name is required';
    if (![0,1].includes(data.gender)) newErrors.gender = 'Gender is required';
    if (!data.dob) newErrors.dob = 'Date of birth is required';

    if (!data.phoneNo) {
      newErrors.phoneNo = 'Phone number is required';
    } else if (!/^\d{10}$/.test(data.phoneNo)) {
      newErrors.phoneNo = 'Phone number must be 10 digits';
    }

    if (!data.email) {
      newErrors.email = 'Email is required';
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!data.address.trim()) newErrors.address = 'Address is required';
    if (!data.branch) newErrors.branch = 'Branch is required';
    if (!data.role) newErrors.role = 'Role is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e, key) => {
    const value = e.target.value;
    setData((prev) => ({ ...prev, [key]: value }));
    setErrors((prev) => ({ ...prev, [key]: '' }));
  };

  const handleSubmit = async () => {
    if (!validate()) return;

    setLoading(true);
    try {
      const res = await ApiServices.post('user/register', data);
      if (res.status === 201) {
        enqueueSnackbar(res?.data?.message || 'Registered successfully', {
          variant: 'success'
        });
        setData({ ...registerData });
        setErrors({})
      } else {
        enqueueSnackbar(res?.data?.message || 'Something went wrong', {
          variant: 'error'
        });
      }
    } catch (error) {
      const err = error?.response?.data?.message || 'Register failed.';
      enqueueSnackbar(err, { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
    setBranchTab(storedUser?.branch_tab || []);
    setRoleTab(storedUser?.role_tab || []);
  }, []);


  console.log(data)
  console.log(errors)

  return (
    <Box sx={{ width: '100%', bgcolor: '#f0f2f5', py: 5 }}>
      <Paper
        elevation={4}
        sx={{
          maxWidth: 600,
          mx: 'auto',
          p: 4,
          borderRadius: 3,
          background: 'white',
        }}
      >
        <Typography variant="h5" fontWeight={600} gutterBottom>
          Register New Employee
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          Fill in the employee details below.
        </Typography>

        <div style={fieldStyle}>
          <TextField
            label="Full Name *"
            fullWidth
            variant="outlined"
            size="medium"
            value={data.name}
            error={!!errors.name}
            helperText={errors.name}
            onChange={(e) => handleChange(e, 'name')}
          />
        </div>

        <div style={fieldStyle}>
          <FormControl fullWidth size="medium" error={!!errors.gender}>
            <InputLabel id="gender-label">Gender *</InputLabel>
            <Select
              labelId="gender-label"
              label="Gender"
              value={data.gender}
              onChange={(e) => handleChange(e, 'gender')}
            >
              <MenuItem value= {0} >Male</MenuItem>
              <MenuItem value= {1} >Female</MenuItem>
            </Select>
            {errors.gender && <FormHelperText>{errors.gender}</FormHelperText>}
          </FormControl>
        </div>

        <div style={fieldStyle}>
          <TextField
            label="Date of Birth *"
            type="date"
            fullWidth
            size="medium"
            InputLabelProps={{ shrink: true }}
            value={data.dob}
            error={!!errors.dob}
            helperText={errors.dob}
            onChange={(e) => handleChange(e, 'dob')}
          />
        </div>

        <div style={fieldStyle}>
          <TextField
            label="Phone Number *"
            fullWidth
            size="medium"
            type="tel"
            inputProps={{ maxLength: 10 }}
            value={data.phoneNo}
            error={!!errors.phoneNo}
            helperText={errors.phoneNo}
            onChange={(e) => handleChange(e, 'phoneNo')}
          />
        </div>

        <div style={fieldStyle}>
          <TextField
            label="Email Address *"
            fullWidth
            size="medium"
            type="email"
            value={data.email}
            error={!!errors.email}
            helperText={errors.email}
            onChange={(e) => handleChange(e, 'email')}
          />
        </div>

        <div style={fieldStyle}>
          <TextField
            label="Address *"
            multiline
            rows={3}
            fullWidth
            size="medium"
            value={data.address}
            error={!!errors.address}
            helperText={errors.address}
            onChange={(e) => handleChange(e, 'address')}
          />
        </div>

        <div style={fieldStyle}>
          <FormControl fullWidth size="medium" error={!!errors.branch}>
            <InputLabel id="branch-label">Branch *</InputLabel>
            <Select
              labelId="branch-label"
              label="Branch"
              value={data.branch}
              onChange={(e) => handleChange(e, 'branch')}
            >
              {branchTab?.map((item) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.branch}
                </MenuItem>
              ))}
            </Select>
            {errors.branch && <FormHelperText>{errors.branch}</FormHelperText>}
          </FormControl>
        </div>

        <div style={fieldStyle}>
          <FormControl fullWidth size="medium" error={!!errors.role}>
            <InputLabel id="role-label">Role *</InputLabel>
            <Select
              labelId="role-label"
              label="Role"
              value={data.role}
              onChange={(e) => handleChange(e, 'role')}
            >
              {roleTab?.map((item) => (
                <MenuItem key={item?.id} value={item?.id}>
                  {item?.role}
                </MenuItem>
              ))}
            </Select>
            {errors.role && <FormHelperText>{errors.role}</FormHelperText>}
          </FormControl>
        </div>

        <Box mt={3} display="flex" justifyContent="center">
          <Button
            variant="contained"
            size="large"
            onClick={handleSubmit}
            disabled={loading}
            sx={{
              px: 5,
              py: 1.5,
              fontWeight: 'bold',
              borderRadius: 2,
              background: '#1976d2',
              '&:hover': { background: '#1565c0' },
            }}
          >
            {loading ? (
              <CircularProgress size={24} sx={{ color: 'white' }} />
            ) : (
              'Submit'
            )}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default AddEmployeePage;
